import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { MapPin, Clock, Wifi } from "lucide-react";
import { toast } from "sonner";

export default function VolunteerPortal() {
    const { user } = useAuth();
    const [opps, setOpps] = useState([]);

    useEffect(() => { api.get("/volunteer/opportunities").then((r) => setOpps(r.data)); }, []);

    async function signup(o) {
        if (!user) return toast.error("Sign in to volunteer");
        try {
            await api.post("/volunteer/signup", { opportunity_id: o.id });
            toast.success(`You've signed up for "${o.title}". They'll reach out soon.`);
        } catch { toast.error("Could not sign up. Try again."); }
    }

    return (
        <div data-testid="volunteer-portal">
            <div className="bg-[var(--rl-cream)] border-b border-[var(--rl-border)]">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
                    <div className="eyebrow mb-3">Volunteer Portal</div>
                    <h1 className="font-serif text-4xl lg:text-6xl tracking-tight max-w-2xl">Every hour matters.<br />Especially yours.</h1>
                    <p className="mt-4 text-[var(--rl-text-2)] max-w-xl">Walk dogs, drive transports, write grants, or run social media — every skill has a place in rescue.</p>
                </div>
            </div>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
                <h2 className="font-serif text-3xl mb-6">Open opportunities</h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {opps.map((o) => (
                        <div key={o.id} className="card-warm rounded-xl p-6" data-testid={`opp-${o.id}`}>
                            <div className="flex items-start justify-between gap-3 mb-2">
                                <h3 className="font-serif text-2xl">{o.title}</h3>
                                {o.remote && <Badge className="bg-[var(--rl-success)] text-white hover:bg-[var(--rl-success)]"><Wifi className="w-3 h-3 mr-1" /> Remote</Badge>}
                            </div>
                            <div className="text-sm text-[var(--rl-text-2)] font-semibold">{o.org_name}</div>
                            <div className="flex items-center gap-4 text-xs text-[var(--rl-text-3)] mt-2">
                                <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {o.location}</span>
                                <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {o.hours_per_week} hrs/wk</span>
                            </div>
                            <p className="text-sm text-[var(--rl-text-2)] mt-3">{o.description}</p>
                            <div className="flex flex-wrap gap-1.5 mt-3">
                                {o.skills.map((s) => <Badge key={s} variant="outline" className="text-[10px] uppercase tracking-widest">{s}</Badge>)}
                            </div>
                            <Button className="btn-primary rounded-full h-10 mt-5" onClick={() => signup(o)} data-testid={`opp-signup-${o.id}`}>Sign me up</Button>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
